module.exports = __webpack_public_path__ + "svg/illustration-principal.ad31e5e.svg";